import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import imagePath from "../../components/CSS/imagePath";
import Navigation from "./../../../src/components/Layouts/Header/Navigation";
import "./css/accountCreate.css";
import { ToastContainer, toast } from "react-toastify";
import { serverInfo } from "../../App";
import noImage from '../../Assets/Images/no-image-profile.png'

const AccountCreate = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [file, setFile] = useState("");
  const [user, setUser] = useState([]);
  const [interest, setInterestType] = useState([]);
  const [modal, setModal] = useState(false);
  const [imagedata, setImagedata] = useState(noImage);

  const [button, setButton] = useState(true);

  const [selectInterest, setSelectInterest] = useState([]);

  const history = useHistory();

  const handleChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImagedata(file[0]);
  };

  function ModalClick(event) {
    event.preventDefault();
    setModal(!modal);
    history.push("/coreCategory");
  }

  const [registerInput, setRegister] = useState({});

  const [infoInput, setInfo] = useState({});

  const [dateInput, setDate] = useState("");
  const [countryInput, setCountry] = useState("");
  const [formInfo, setFormInfo] = useState();

  //const [regvalue,setRegValue]=useState('');

  const handleInput = (e) => {
    e.persist();
    setRegister({ ...registerInput, [e.target.name]: e.target.value });
  };

  const handleInfo = (e) => {
    e.persist();
    setInfo({ ...infoInput, [e.target.name]: e.target.value });
  };

  const handleDateInput = (e) => {
    setDate(e.target.value);
  };

  const handleCountryInput = (e) => {
    setCountry(e.target.value);
  };

  const handleSelectInterest = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectInterest([...selectInterest, parseInt(value)]);
    } else {
      setSelectInterest(selectInterest.filter((e) => e !== parseInt(value)));
    }
  };

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user_info`).then((res) => {
        setButton(false);
        if (res.status === 200) {
          setUser(res.data.users);
          setRegister(res.data.users);
          setInfo(res.data.info);
          setFile(`${res.data.users.image ? imageCdnUrl + res.data.users.image : noImage}`);
          //setDate(registerInput.user_info != null ? registerInput.user_info.dob : '')
          setDate(
            res.data.users.user_info != null ? res.data.users.user_info.dob : ""
          );
          setCountry(
            res.data.users.user_info != null
              ? res.data.users.user_info.country
              : ""
          );
        }
      });

    axios.get(`/api/user/create-user-info`).then((res) => {
      if (res.status === 200) {
        setFormInfo(res.data);
      }
    });

    axios.get(`/api/user/interest/type`).then((res) => {
      if (res.status === 200) {
        setInterestType(res.data.allinteresttypes);
      }
    });
  }, []);

  const [infoBuffer, setInfoBuffer] = useState(false);
  const registerSubmit = (e) => {
    e.preventDefault();

    setInfoBuffer(true);

    const fData = new FormData();

    fData.append("image", imagedata);
    fData.append("first_name", registerInput?.first_name);
    fData.append("last_name", "");
    fData.append("phone", registerInput.phone);
    fData.append("email", registerInput.email);
    fData.append("dob", dateInput == "" ? 0 : dateInput);
    fData.append("country", countryInput);

    fData.append("occupation", infoInput?.occupation);
    fData.append("edu_level", infoInput?.edu_level);
    fData.append("institute", infoInput?.institute);
    fData.append("subject", infoInput?.subject);
    fData.append("position", infoInput?.position);
    fData.append("company", infoInput?.company);
    fData.append("salery_range", infoInput?.salery_range ? infoInput?.salery_range : 0);
    fData.append("interest_topic_id", JSON.stringify(selectInterest));

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/user_info_update`, fData)
        .then((res) => {
          setInfoBuffer(false);
          if (res.data.status === 200) {
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setModal(!modal);
          } else if (res.data.status === 401) {
            swal("Warning", res.data.message, "warning");
          } else {
            setRegister({
              ...registerInput,
              error_list: res.data.validation_errors,
            });
          }
        })
        .catch((err) => {

          setInfoBuffer(false);
          toast.warning("All field required !", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    });
  };
  const [otherInfoBuffer, setOtherInfoBuffer] = useState(false);
  // const infoSubmit = (e) => {
  //   e.preventDefault();
  //   setOtherInfoBuffer(true);

  //   const fData = new FormData();

  //   fData.append("occupation", infoInput.occupation);
  //   fData.append("edu_level", infoInput.edu_level);
  //   fData.append("institute", infoInput.institute);
  //   fData.append("subject", infoInput.subject);
  //   fData.append("position", infoInput.position);
  //   fData.append("company", infoInput.company);
  //   fData.append("salery_range", infoInput.salery_range);

  //   axios.get("/sanctum/csrf-cookie").then((response) => {
  //     axios
  //       .post(`/api/user_otherInfo_update`, fData)
  //       .then((res) => {
  //         setOtherInfoBuffer(false);
  //         if (res.data.status === 200) {
  //           toast.success("User infos update successfully", {
  //             position: "top-right",
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //           });

  //           setModal(!modal);
  //         } else if (res.data.status === 401) {
  //           swal("Warning", res.data.message, "warning");
  //         } else {
  //           setRegister({
  //             ...registerInput,
  //             error_list: res.data.validation_errors,
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         setOtherInfoBuffer(false);
  //         toast.warning("All field required !", {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //         });
  //       });
  //   });
  // };

  return (
    <>
      <Navigation></Navigation>
      <ToastContainer />

      <form
        action=""
        onSubmit={registerSubmit}
        // onSubmit={infoSubmit}
        className="container  mt-4 mb-4 px-4 custom-skip-p"
      >
        <div className="row justify-content-between  card-bg1">
          <div className="col-sm-12 col-md-4 col-lg-4 p-4 mb-3">
            <div className="card card-bg1 border-0 p-4">
              <center className="proNewPosition">
                {" "}
                <img
                  src={file ? file : noImage}
                  alt=""
                  className="proNew-img p-1"
                />
                <span>
                  <label For="id">
                    <i className="fa-solid fa-camera  icon-btn "></i>
                  </label>

                  <input
                    type="file"
                    className="d-none"
                    id="id"
                    onChange={(e) => handleChange(e.target.files)}
                  />
                </span>
              </center>

              <div className="row mt-4">
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Name</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="text"
                    onChange={handleInput}
                    name="first_name"
                    value={registerInput.first_name}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your name"
                  />
                </div>
                {/* 
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Last name</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="text"
                    value={registerInput.last_name}
                    onChange={handleInput}
                    name="last_name"
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your last name"
                  />
                </div> */}

                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Email</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="email"
                    onChange={handleInput}
                    name="email"
                    value={registerInput.email}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your email"
                  />
                </div>

                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Phone</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="text"
                    onChange={handleInput}
                    name="phone"
                    value={registerInput.phone}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your number"
                  />
                </div>

                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Date</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="date"
                    name="dob"
                    value={dateInput}
                    onChange={handleDateInput}
                    className="from-control w-100 custom-con-input form-control-sm "
                  />
                </div>

                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Country</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <select
                    className="form-control form-control-sm account-input-style"
                    onChange={handleCountryInput}
                    name="country"
                    value={countryInput}
                  >
                    <option value="">Select Your Country</option>
                    {formInfo?.country &&
                      formInfo?.country.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-8 col-lg-5 mb-3 p-4 ">
            <div className="card card-bg1  p-4 custom-das-border border-0">
              <h5 className="text-warning fw-bold">Field of interest</h5>
              <div className="row mt-3">
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Occupation</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <select
                    className="form-control form-control-sm account-input-style"
                    onChange={handleInfo}
                    name="occupation"
                    value={infoInput?.occupation}
                  >
                    <option value="">Select your Occupation</option>
                    {formInfo?.occupation &&
                      formInfo?.occupation?.map((item) => (
                        <option value={item.title}>{item.title}</option>
                      ))}
                  </select>
                </div>
              </div>

              <h5 className="text-warning fw-bold mt-3">Education Info</h5>
              <div className="row mt-3">
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Education</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <select
                    className="form-control form-control-sm account-input-style"
                    onChange={handleInfo}
                    name="edu_level"
                    value={infoInput?.edu_level}
                  >
                    <option value="">Select Your Education</option>
                    {formInfo?.educationlevel &&
                      formInfo?.educationlevel.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                  </select>
                </div>
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Institute Name</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="text"
                    onChange={handleInfo}
                    name="institute"
                    value={infoInput?.institute}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your institute"
                  />
                </div>
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Subject</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="text"
                    onChange={handleInfo}
                    name="subject"
                    value={infoInput?.subject}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your subject"
                  />
                </div>
              </div>

              <h5 className="text-warning fw-bold mt-3">Employment</h5>
              <div className="row mt-3">
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Designation</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="text"
                    onChange={handleInfo}
                    name="position"
                    value={infoInput?.position}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your designation"
                  />
                </div>
                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Govt / Company</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="text"
                    onChange={handleInfo}
                    name="company"
                    value={infoInput?.company}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your govt / company"
                  />
                </div>

                <div className="d-flex col-sm-12 col-md-12 col-lg-4 text-light justify-content-lg-between">
                  <div>Salary</div>
                  <div>&nbsp;:</div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8 mb-3">
                  <input
                    type="number"
                    onChange={handleInfo}
                    name="salery_range"
                    value={infoInput?.salery_range}
                    className="from-control w-100 custom-con-input form-control-sm "
                    placeholder="Enter your salary"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-8 col-lg-3 mb-3 p-4 ">
            <div className="card card-bg1 border-0 p-4 custom-das-border">
              <h5 className="text-warning fw-bold">Field of interest</h5>

              {interest?.map((event) => (
                <div className="form-check mt-2">
                  <input
                    className="form-check-input mt-1"
                    type="checkbox"
                    value={event.id}
                    id="flexCheckChecked"
                    onChange={handleSelectInterest}
                  />
                  <label
                    className="form-check-label text-light LabelField"
                    htmlFor="flexCheckChecked"
                  >
                    {event.interest_type}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="row justify-content-center mt-3 mb-5">
            <div className="col-md-2">
              {button ? (
                <></>
              ) : (
                <button className="btn BTnInfo w-100 fw-bold">
                  {infoBuffer ? (
                    <>
                      {" "}
                      <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                    </>
                  ) : (
                    <></>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>

          <Link to="/coreCategory">
            <div className="custom-skip px-3 ">skip</div>
          </Link>

          {modal && (
            <div className="modal-container1">
              <div onClick={ModalClick} className="overlay-color1"></div>
              <div className="modal-content1">
                <p className="text-light">
                  Would you like to get our newsletter and promotional offers
                  through email?
                </p>
                <div className="choose-btn1">
                  <Link to="/coreCategory" className="btn btn-top-up w-25">
                    Yes
                  </Link>
                  <button
                    className="btn btn-top-up-n w-25"
                    onClick={ModalClick}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </form>
    </>
  );
};

export default AccountCreate;
